// Public UI adapted from Klargo-Reference/components/layout/Header.tsx.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher, { useLanguage } from './LanguageSwitcher.jsx';
import { KlargoLogo } from '../common/KlargoLogo.jsx';
import { LoginDialog } from '../auth/LoginDialog.jsx';
import { useAuth } from '../../contexts/AuthContext.jsx';
import { LogOut, User, Menu, X } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from '../ui/dropdown-menu.jsx';
const inkActionClass = 'press inline-flex h-10 items-center rounded-[9px] bg-ds-ink px-[18px] text-[14px] font-semibold text-ds-ink-on hover:bg-ds-ink-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
const outlineActionClass = 'press inline-flex h-10 items-center gap-2 rounded-[9px] border border-[color:var(--ds-rule-control)] px-[18px] text-[14px] font-semibold text-ds-ink hover:bg-[rgba(20,36,46,.05)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';
const Header = () => {
    const navigate = useNavigate();
    const { isAuthenticated, user, logout } = useAuth();
    const { t } = useLanguage();
    const [loginOpen, setLoginOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const handleLogoClick = (e) => {
        if (e.altKey) {
            navigate("/Home");
        }
        else if (isAuthenticated) {
            // "/" and "/Home" are the logged-out landing page; a signed-in user's home is the overview.
            navigate('/user/ChooseAction');
        }
        else {
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
    const handleLoginClick = () => {
        setMobileMenuOpen(false);
        setLoginOpen(true);
    };
    return (<>
      <header className={`sticky top-0 z-50 border-b border-ds-rule-row bg-ds-sheet font-ds-sans text-ds-body antialiased transition-shadow duration-200 ${scrolled ? 'shadow-[0_1px_0_rgba(20,36,46,.08),0_6px_16px_-10px_rgba(16,30,40,.18)]' : ''}`}>
        <div className="mx-auto max-w-[1200px] px-5 md:px-8">
          <div className="flex h-[60px] items-center justify-between">
            
            <div className="flex items-center">
              <button onClick={handleLogoClick} className="cursor-pointer rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" aria-label={t('nav.logoHome')}>
                <KlargoLogo variant="header"/>
              </button>
            </div>

            

            
            <div className="flex items-center gap-2">
              <div className="hidden sm:block">
                <LanguageSwitcher />
              </div>

              {isAuthenticated ? (<DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button type="button" className={`hidden sm:inline-flex ${outlineActionClass}`}>
                      <User className="h-4 w-4"/>
                      <span className="max-w-[120px] truncate">
                        {user?.fullName || user?.email}
                      </span>
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="bg-white border border-border shadow-lg z-50">
                    <DropdownMenuItem onClick={logout} className="text-destructive cursor-pointer">
                      <LogOut className="mr-2 h-4 w-4"/>
                      Logga ut
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>) : (<button type="button" onClick={handleLoginClick} className={`hidden sm:inline-flex ${inkActionClass}`}>
                  {t('Logga in')}
                </button>)}

              
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="rounded-lg p-2 text-ds-text transition-colors hover:text-ds-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 md:hidden" aria-label={mobileMenuOpen ? t('Stäng meny') : t('Öppna meny')} aria-expanded={mobileMenuOpen} aria-controls="public-mobile-menu">
                {mobileMenuOpen ? <X className="h-5 w-5"/> : <Menu className="h-5 w-5"/>}
              </button>
            </div>
          </div>

          
          {mobileMenuOpen && (<div id="public-mobile-menu" className="space-y-1 border-t border-ds-rule-row pb-4 pt-2 md:hidden">
              <div className="flex items-center justify-between">
                <LanguageSwitcher />

                {isAuthenticated ? (<button type="button" onClick={logout} className={outlineActionClass}>
                    <LogOut className="h-4 w-4"/>
                    Logga ut
                  </button>) : (<button type="button" onClick={handleLoginClick} className={outlineActionClass}>
                    {t('Logga in')}
                  </button>)}
              </div>
            </div>)}
        </div>
      </header>
      
      <LoginDialog open={loginOpen} onOpenChange={setLoginOpen} resumePending/>
    </>);
};
export default Header;
